// Packages
import React, { Component } from 'react';
import Modal from 'react-modal';
import { connect } from 'react-redux';
import { WithTranslation } from 'react-i18next';
// React JSX Components
import ButtonSpinner from '../Spinners/ButtonSpinner';
import ScheduleDeliveryForm, { ScheduleDeliveryFormRef } from '../ScheduleDeliveryForm';
// Redux Dispatch Actions
// Utilities
// Types
import { ReduxRootState } from '../../Interfaces/ReduxInterface/ReduxRootState';
import { MarketPlaceCompanyAddress } from '../../Interfaces/PayloadsAndResponses/Company';
// CSS



const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    width: '752px',
    padding: '0'
  }
};

Modal.setAppElement('#root');
Modal.defaultStyles.overlay!.backgroundColor = 'rgba(0,0,0,0.75)';
Modal.defaultStyles.overlay!.zIndex = 6;

export type MarketplaceMeeting = {
  mealType: string;
  deliveryInstructions: string | undefined;
  selectedCompanyAddress: MarketPlaceCompanyAddress | undefined;
  selectedCompanyAddressID: number | undefined;
}

type MeetingDetailsPopUpProps = {
  i18n: WithTranslation | null,
  onRef: (ref: MeetingDetailsPopUpRef | null) => void,
  selectedDate: Date | undefined,
  selectedType?: string | null,
  selectedAddress?: string | null,
  onUpdatePage: () => void,
  fromDashboard?: boolean,
  marketPlace?: boolean,
  meeting?: MarketplaceMeeting,
  selectedRestaurants?: number[],
  createSchedular?: boolean,
}
export type MeetingDetailsPopUpState = {
  modalIsOpen: boolean,
  meetingUpdateSlug: string | undefined,
  showLoading: boolean,
  pending: boolean,
  meetingStatus: string | undefined,
  requiredFields: boolean,
}
class MeetingDetailsPopUp extends Component<MeetingDetailsPopUpProps, MeetingDetailsPopUpState> {

  state = {
    modalIsOpen: false,
    meetingUpdateSlug: '',
    showLoading: false,
    pending: false,
    meetingStatus: '',
    requiredFields: false
  };

  componentDidMount() {
    this.props.onRef(this)
  }
  componentWillUnmount() {
    this.props.onRef(null)
  }
  openModal = (meetingUpdateSlug?: string, meetingStatus?: string, requiredFields = false) => {
    if (meetingUpdateSlug) {
      this.setState({ pending: true })
    } else {
      this.setState({ pending: false })
    }
    this.setState({ modalIsOpen: true, meetingUpdateSlug: meetingUpdateSlug, meetingStatus: meetingStatus, requiredFields: requiredFields });
  }
  closeModal = () => {
    this.setState({ modalIsOpen: false });
  }
  handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    this.setState({ [e.target.name]: e.target.value } as unknown as MeetingDetailsPopUpState)
  }
  onSubmit = () => {
    this.sch_req_form?.onSubmit();
  }

  sch_req_form = React.createRef<ScheduleDeliveryFormRef>().current;

  render() {
    return (
      <Modal
        isOpen={this.state.modalIsOpen}
        onRequestClose={this.closeModal}
        style={{ ...customStyles, content: { ...customStyles?.content, borderRadius: this.props?.fromDashboard ? '18px' : '4px' } }}
        contentLabel='Example Modal'
      >
        <div className='order-modal' id='orderModelBox'>
          <div className='modal-dialog' style={{ maxWidth: '100%' }}>
            <div className='modal-content' style={{ border: 'none' }}>
              {(this.props.marketPlace) ?
                <div className='modal-header' style={{ width: 750 }}>
                  <h5 className='modal-title' id='modal-title'> {(this.props.i18n && this.props.i18n.t('Update Delivery Details'))} </h5>
                  <button type='button' onClick={this.closeModal} className='close' data-dismiss='modal' aria-label='Close'><span aria-hidden='true'>×</span></button>
                </div> :
                <div className={`modal-header ${this.props?.fromDashboard ? 'bg-white' : ''}`} style={{ width: 750 }}>
                  <h5 className='modal-title' id='modal-title'> {this.state.pending === false ? (this.props.i18n && this.props.i18n.t('Schedule Delivery')) : this.state.meetingStatus === 'approved' ? (this.props.i18n && this.props.i18n.t('Update Delivery Details')) : (this.props.i18n && this.props.i18n.t('Pending Approval'))} </h5>
                  <button type='button' onClick={this.closeModal} className='close' data-dismiss='modal' aria-label='Close'>
                    <span aria-hidden='true'>
                      {this.props?.fromDashboard ? <i className='far fa-times-circle'></i> : '×'}
                    </span>
                  </button>
                </div>
              }
              <div id='mydiv' className='modal-body' style={{ width: 750 }}>
                {/* use props from msrketplace are, selectedRestaurants, marketPlace, meeting  */}
                <ScheduleDeliveryForm
                  selectedDate={this.props.selectedDate}
                  selectedType={this.props.selectedType}
                  selectedAddress={this.props.selectedAddress}
                  meetingUpdateSlug={this.state.meetingUpdateSlug}
                  meetingStatus={this.state.meetingStatus}
                  onRef={(ref: ScheduleDeliveryFormRef | null) => { this.sch_req_form = ref }}
                  setState={(p: MeetingDetailsPopUpState) => { this.setState(p) }}
                  closeModal={this.closeModal}
                  onUpdatePage={this.props.onUpdatePage}
                  requiredFields={this.state.requiredFields}
                  marketPlace={this.props.marketPlace}
                  selectedRestaurants={this.props.selectedRestaurants}
                  meeting={this.props.meeting}
                  createSchedular = {this.props.createSchedular}
                />
              </div>
              <div className={`modal-footer ${this.props?.fromDashboard ? 'bg-white' : ''}`} style={{ width: 750 }}>
                <button
                  type='submit'
                  onClick={this.onSubmit}
                  className={`confirm-update-delivery ml-3 btn delivery-btn-width ${this.state.pending === false ? 'btn-primary ' : 'btn-warning'}`}
                >
                  {(!this.props.marketPlace) && this.state.pending === false ?
                    (this.state.showLoading === true) ?
                      <ButtonSpinner /> :
                      (this.props.i18n && this.props.i18n.t('Schedule Delivery')) :
                    (this.state.showLoading === true) ? <ButtonSpinner /> :
                      (this.props.i18n && this.props.i18n.t('Update Delivery'))}
                </button>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    )
  }
}

const mapStateToProps = (state: ReduxRootState) => ({
  i18n: state.i18n.i18n
});

export type MeetingDetailsPopUpRef = React.ElementRef<typeof MeetingDetailsPopUp>;

export default connect(mapStateToProps, {})(MeetingDetailsPopUp);